import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { CatalogAdjustmentType } from "../models/CatalogAdjustmentType";

export const getAdjustmentTypes = async (
	params: { adjustmentTypeId?: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.adjustmentTypeId)
		parameters.push({
			name: "AdjustmentTypeId",
			value: params.adjustmentTypeId,
		});

	const resp = await apiService.callV2(
		"[M2].[GetAdjustmentTypes]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as CatalogAdjustmentType[];
	} else {
		throw new Error(resp.message || "Error fetching adjustment types");
	}
};
export const upsertAdjustmentType = async (
	adjustmentType: CatalogAdjustmentType,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "AdjustmentTypeId", value: adjustmentType.AdjustmentTypeId },
		{ name: "AdjustmentTypeName", value: adjustmentType.AdjustmentTypeName },
		{ name: "RequiredValue", value: adjustmentType.RequiredValue },
		{ name: "RequiredReason", value: adjustmentType.RequiredReason },
		{ name: "Unit", value: adjustmentType.Unit },
	];

	const resp = await apiService.callV2(
		"[M2].[UpsertAdjustmentType]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error upserting adjustments reasons");
	}
};

export const deleteAdjustmentType = async (adjustmentTypeId: number | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "AdjustmentTypeId", value: adjustmentTypeId },
	];

	const resp = await apiService.callV2(
		"[M2].[DeleteAdjustmentType]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting adjustments types");
	}
};
